<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.purchaseStatus === 'N'
              ? 'primary'
              : row.purchaseStatus === 'D'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_purchaseStatus }}
        </el-tag>
      </template>

      <template v-slot:reviewInfo="{ row }">
        <span> {{ row.reviewByName }} </span>
        <br />
        <span> {{ row.reviewTime }} </span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span> {{ row.createByName }} </span>
        <br />
        <span> {{ row.createTime }} </span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span> {{ row.modifyByName }} </span>
        <br />
        <span> {{ row.modifyTime }} </span>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || 查看"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.purchasePackageCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            v-if="row.purchaseStatus === 'N'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.purchasePackageCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="row.purchaseStatus === 'N'"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del({ code: row.purchasePackageCode })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            v-if="row.purchaseStatus === 'N'"
            placement="top"
          >
            <i
              class="el-icon-check tool-btn"
              @click="audit({ code: row.purchasePackageCode })"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height"
import tableColumns from "./table-columns"

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ code }) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .purchasePackageDelApi({ purchasePackageCode: code })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            })
            this.$emit("reload")
          })
      })
    },
    audit({ code }) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .purchasePackageAuditApi({ purchasePackageCode: code })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "审核成功！",
              type: "success",
            })
            this.$emit("reload")
          })
      })
    },
  },
}
</script>
